import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import type { KpiItem } from "./monetizationModel";

/** A titled card of small stat boxes; the page feeds it sales, conversion and retention facts. */
export function MonetizationKpiGrid({
  title,
  items,
  footnote,
}: {
  title: string;
  items: KpiItem[];
  footnote?: string;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
          {items.map((item) => (
            <div key={item.label} className="rounded-lg border bg-muted/20 p-3">
              <p className="text-xs text-muted-foreground">{item.label}</p>
              <p className="mt-1 text-2xl font-semibold tabular-nums">
                {item.value}
              </p>
              {item.hint ? (
                <p className="mt-1 text-xs text-muted-foreground">
                  {item.hint}
                </p>
              ) : null}
            </div>
          ))}
        </div>
        {footnote ? (
          <p className="text-xs text-muted-foreground">{footnote}</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
